import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core';
import styles from './ErrorDialog.module.css';
import { useTranslation } from 'react-i18next';

const ErrorDialog = ({ open, onClose }) => {
  const { t } = useTranslation();
  return (
    <Dialog open={open} onClose={onClose} className={styles.dialog}>
      <DialogTitle>{t('templates.errorDialogTitle')}</DialogTitle>
      <DialogContent>
        <DialogContentText>{t('templates.errorDialogContent')}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color='primary'>
          {t('common.ok')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ErrorDialog;
